module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<dl class=\'stepped zero\'>\n    ';
 if (showHeader) { ;
__p += '\n        <dt>\n            ' +
((__t = ( i18next.t('common.type') )) == null ? '' : __t) +
'\n        </dt>\n        <dd>\n            ' +
((__t = ( tarType )) == null ? '' : __t) +
'\n        </dd>\n        <dt>\n            ' +
((__t = ( i18next.t('common.name') )) == null ? '' : __t) +
'\n        </dt>\n        <dd>\n            ' +
((__t = ( tarName )) == null ? '' : __t) +
'\n        </dd>\n    ';
 } ;
__p += '\n    <dt>\n        <label for="tar-interval">\n            ' +
((__t = ( i18next.t('common.intervals') )) == null ? '' : __t) +
'\n        </label>\n    </dt>\n    <dd>\n        <select class="text" id="tar-interval" style="text-transform: none">\n        </select>\n    </dd>\n    <div class=\'' +
((__t = ( showHeader ? '' : ' no-border' )) == null ? '' : __t) +
'\' id="tar-values">\n    </div>\n</dl>\n\n\n';

}
return __p
}